"use client"

import {FormProvider, type SubmitHandler, useForm} from "react-hook-form";
import ContactForm, {type ContactFormInput} from "./ContactForm";
import FullscreenModal from "~/components/ui/FullscreenModal";
import ContactIllustration from "~/assets/contact/contact.png";
import LeftSectionComponent from "~/components/ui/LeftSectionComponent";
import {useState} from "react";
import {postEmailRequest} from "~/app/api/_backend/contact";

export default function ContactSection() {
  const [messageModal, setMessageModal] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [error, setError] = useState<boolean | null>(false);
  const [success, setSuccess] = useState(false);

  const methods = useForm<ContactFormInput>();
  const { formState, reset, handleSubmit } = methods;

  const openModal = (b: boolean) => {
    setMessageModal(b);
    if (!b) {
      setSuccess(false);
      setError(null);
      reset();
    }
  };

  const onSubmit: SubmitHandler<ContactFormInput> = async (data) => {
    setSubmit(true);
    try {
      await postEmailRequest({
        name: data.name,
        email: data.email,
        message: data.message,
      });
      setSuccess(true);
    } catch {
      setError(true);
    }
    setSubmit(false);
  };

  return <>
    <LeftSectionComponent
      image={ContactIllustration}
      subtitle={"Kontaktní formulář"}
      title={"Napište nám zprávu"}
      text={
        "Pokud nás chcete kontaktovat bez použití vlastního e-mailového klienta, tak nám můžete poslat zprávu prostřednictvím kontaktního formuláře."
      }
      variant={{
        visible: { opacity: 1, x: 0, transition: { duration: 0.75 } },
        hidden: { opacity: 0, x: "100%" },
      }}
    >
      <button
        className="btn btn-primary ripple"
        onClick={() => openModal(true)}
      >
        Napsat zprávu
      </button>
    </LeftSectionComponent>
    <FullscreenModal
      open={messageModal}
      setOpenAction={openModal}
      isDirty={formState.isDirty && !success}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ContactForm
            isSubmitted={submit}
            hasError={error ?? false}
            setErrorAction={setError}
            closeModalAction={async () => {
              openModal(false);
            }}
            success={success}
          />
        </form>
      </FormProvider>
    </FullscreenModal>
  </>
}
